"use client";

import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@carbon/react";
import { useEffect, useState, type ReactNode } from "react";
import { documentTabsCopy } from "@/lib/ui/document-view";

type DocumentTabsProps = {
  overview: ReactNode;
  content: ReactNode;
  analysis: ReactNode;
  versions: ReactNode;
  access?: ReactNode;
  defaultSelectedIndex?: number;
  resetKey?: string;
};

export function DocumentTabs({
  overview,
  content,
  analysis,
  versions,
  access,
  defaultSelectedIndex = 0,
  resetKey,
}: DocumentTabsProps) {
  const [selectedIndex, setSelectedIndex] = useState(defaultSelectedIndex);

  useEffect(() => {
    setSelectedIndex(defaultSelectedIndex);
  }, [resetKey, defaultSelectedIndex]);

  const tabs = [
    { label: documentTabsCopy.overview, content: overview, pane: true },
    { label: documentTabsCopy.content, content: content, pane: true },
    { label: documentTabsCopy.analysis, content: analysis, pane: false },
    { label: documentTabsCopy.versions, content: versions, pane: true },
    ...(access
      ? [{ label: documentTabsCopy.access, content: access, pane: true }]
      : []),
  ];

  return (
    <Tabs
      key={resetKey ?? "document-tabs"}
      selectedIndex={selectedIndex}
      onChange={({ selectedIndex: next }) => setSelectedIndex(next)}
    >
      <TabList aria-label="Документ">
        {tabs.map((tab) => (
          <Tab key={tab.label}>{tab.label}</Tab>
        ))}
      </TabList>
      <TabPanels>
        {tabs.map((tab) => (
          <TabPanel key={tab.label}>
            {tab.pane ? (
              <div className="document-pane">{tab.content}</div>
            ) : (
              tab.content
            )}
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
}
